import Enum from "../../../enums/Enum";

const EnumRestrictionStatus = new Enum({
    REQUESTED: "Requested",
    ACCEPTED: "Accepted",
    REJECTED: "Rejected",
    REVOKED: "Revoked"
});

export default EnumRestrictionStatus;